<!-- NoteCustomTextarea.vue -->
<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  body: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:body", "toggle-expand"]);

const isExpanded = ref(false);

const modelValue = computed({
  get: () => props.body,
  set: (val) => emit("update:body", val),
});

function toggleExpand() {
  if (props.disabled) return;
  isExpanded.value = !isExpanded.value;
  emit("toggle-expand", isExpanded.value);
}

defineExpose({ toggleExpand, isExpanded });
</script>

<template>
  <div :class="['ct-wrapper', isExpanded ? 'ct-expanded' : '']">
    <textarea
      v-model="modelValue"
      class="ct-textarea"
      :class="[isExpanded ? 'ct-textarea-expanded' : '']"
      :disabled="disabled"
      rows="6"
      placeholder="Digite o corpo da nota..."
    ></textarea>
  </div>
</template>

<style scoped>
.ct-wrapper {
  position: relative;
  width: 100%;
}

.ct-textarea {
  width: 100%;
  min-height: 140px;
  padding: 0.75rem; /* ← padding-top volta ao normal, sem espaço pro botão */
  border: 1px solid var(--neutral-400);
  border-radius: 12px;
  resize: vertical;
  outline: none;
  font-size: 0.95rem;
  color: var(--text-dark);
  background: var(--surface-3);
  transition: box-shadow 0.2s, border-color 0.2s;
}

.ct-textarea:focus {
  border-color: var(--brand);
  box-shadow: var(--focus-ring-brand);
}

.ct-textarea-expanded {
  resize: none;
}
</style>